function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { defaultProps } from '../../Icon.constant.js';
import StyledIcon from '../../Icon.style.js';
CloseIcon.propTypes = {
  /** Specify colour name, refer to Foundation colour for more colour. Default is "black" */
  color: PropTypes.string,

  /** Specify icon size. Default is "sm" (24px x 24px) */
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xlg', 'xxlg', 'xxxlg'])
};
CloseIcon.defaultProps = _objectSpread({}, defaultProps);
export function CloseIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 10.947l5.31-5.311a.745.745 0 011.054 1.053L13.054 12l5.31 5.31a.745.745 0 11-1.053 1.054L12 13.054l-5.31 5.31a.745.745 0 11-1.054-1.053L10.946 12l-5.31-5.31a.745.745 0 111.053-1.054L12 10.946z"
  }));
}